import { Link } from 'react-router-dom';
import { Instagram, Mail } from 'lucide-react';
import { useEffect, useState } from 'react';
import api from '@/lib/api';

export function Footer() {
  const [storeSettings, setStoreSettings] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await api.get('/site-builder/store-settings');
        setStoreSettings(res.data);
      } catch (error) {
        console.error('Failed to load store settings');
      }
    };
    fetchSettings();
  }, []);

  const email = storeSettings?.store_email || storeSettings?.social_links?.email || '';
  const instagram = storeSettings?.social_links?.instagram || '';
  const phone = storeSettings?.phone || '';

  return (
    <footer className="bg-stone-50 border-t border-stone-200 mt-32" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-medium mb-4 text-stone-900">Twenty Tulips</h3>
            <p className="text-stone-600 leading-relaxed mb-6">
              Discover our curated collection of premium shawls. Each piece is thoughtfully designed 
              to add elegance and sophistication to your wardrobe.
            </p>
            <div className="flex space-x-4">
              {instagram && (
                <a
                  href={instagram.startsWith('http') ? instagram : `https://instagram.com/${instagram.replace('@', '')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-stone-600 hover:text-stone-900 transition-colors"
                  data-testid="instagram-link"
                >
                  <Instagram className="h-5 w-5" />
                </a>
              )}
              {email && (
                <a
                  href={`mailto:${email}`}
                  className="text-stone-600 hover:text-stone-900 transition-colors"
                  data-testid="email-link"
                >
                  <Mail className="h-5 w-5" />
                </a>
              )}
            </div>
          </div>

          {/* Shop */}
          <div>
            <h4 className="text-sm uppercase tracking-widest font-medium mb-4 text-stone-900">
              Shop
            </h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/collections"
                  className="text-stone-600 hover:text-stone-900 transition-colors text-sm"
                >
                  Collections
                </Link>
              </li>
              <li>
                <Link
                  to="/shop"
                  className="text-stone-600 hover:text-stone-900 transition-colors text-sm"
                >
                  All Products
                </Link>
              </li>
            </ul>
          </div>

          {/* Help */}
          <div>
            <h4 className="text-sm uppercase tracking-widest font-medium mb-4 text-stone-900">
              Help
            </h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/about"
                  className="text-stone-600 hover:text-stone-900 transition-colors text-sm"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-stone-600 hover:text-stone-900 transition-colors text-sm"
                >
                  Contact
                </Link>
              </li>
              <li>
                <Link
                  to="/shipping"
                  className="text-stone-600 hover:text-stone-900 transition-colors text-sm"
                >
                  Shipping & Returns
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="text-stone-600 hover:text-stone-900 transition-colors text-sm"
                >
                  FAQ
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-stone-200 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-stone-600">
              © {new Date().getFullYear()} Twenty Tulips. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link
                to="/privacy"
                className="text-sm text-stone-600 hover:text-stone-900 transition-colors"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                className="text-sm text-stone-600 hover:text-stone-900 transition-colors"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
